<template>      
    <div>
      <sak-lc v-if="org_id == '1'" />
      <sis-lc v-else-if="org_id == '2'" />
      <sav-lc v-else-if="org_id == '3'" />
      <ssjc-lc v-else-if="org_id == '4'" />
      <sjcv-lc v-else-if="org_id == '5'" />
      <sjck-lc v-else-if="org_id == '6'" />          
      <div v-else>Under Development.....</div>
    </div>
</template>
<script>
import saklc from './SakLC.vue';
import sislc from './SisLC.vue';
import savlc from './SavLC.vue';
import ssjclc from './SsjcLC.vue';
import sjcvlc from './SjcvLC.vue';
import sjcklc from './SjckLC.vue';
export default {
  components: {
    'sak-lc': saklc,
    'sis-lc': sislc,
    'sav-lc': savlc,
    'ssjc-lc': ssjclc,
    'sjcv-lc': sjcvlc,
    'sjck-lc': sjcklc,    
  },
  data() {
    return {
      org_id: null,
    };
  },
  mounted() {
    this.org_id = localStorage.getItem("EPS-org-id")
  },
};
</script>
<style scoped>
</style>
